<template>
  <unicom-modal-acao
    v-model="valueData"
    :larguraModal="500"
    textoTitulo="Deseja sair da edição?"
    mensagem="Existe uma edição em andamento. Ao sair, as alterações realizadas serão perdidas."
    textoBotaoConfirmar="EDITAR"
    tipoBotao="importante"
    :larguraBotaoConfirmar="144"
    @botao-confirmar="$emit('botao-confirmar')"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  data() {
    return {
      valueData: false
    };
  },
  watch: {
    value() {
      this.valueData = this.value;
    },
    valueData() {
      this.$emit("input", this.valueData);
    }
  }
};
</script>
